import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import TermsOfPolicyModal from '~/shared/components/modals/auth/TermsOfPolicyModal'
import { isNestedModalOpenState } from '~/shared/states'

const NestedModal = () => {
  const [isNestedModalOpen] = useRecoilState(isNestedModalOpenState)

  return (
    <Wrapper>
      {isNestedModalOpen.contents === 'terms-of-policy' ? (
        <TermsOfPolicyModal />
      ) : (
        <></>
      )}
    </Wrapper>
  )
}

export default NestedModal

const Wrapper = styled.div`
  display: flex;
`
